import React, { Component } from "react";
import {
    Paper,
    Typography,
    Button,
    List,
    ListItem,
    ListItemAvatar,
    Avatar,
    ListItemText,
    ListItemSecondaryAction,
    FormControl,
    IconButton,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import FolderIcon from "@material-ui/icons/Folder";

export default class JobPackUploadFiles extends Component {
    constructor(props) {
        super(props);
        this.state = {
            profile: props.profile,
            fileProgress: false,
            fileSuccess: false,
            fileFail: false,
            edit: this.props.edit,
        };
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.profile !== this.props.profile) {
            this.setState({ profile: this.props.profile });
        }
    }

    render() {
        const { profile } = this.state;
        return (
            <Paper
                style={{
                    padding: 20,
                    textAlign: "center",
                }}
            >
                <Typography style={{ marginBottom: 30 }} variant="h5">
                    Upload Files
                </Typography>

                <div>
                    <FormControl>
                        {this.state.fileProgress !== false && (
                            <p
                                style={{
                                    width: "100%",
                                    background: "orange",
                                    padding: "1em",
                                    color: "white",
                                    fontWeight: "600",
                                    borderRadius: 4,
                                }}
                            >
                                File Upload Progress: {this.state.fileProgress}%
                            </p>
                        )}
                        {this.state.edit && (
                            <React.Fragment>
                                <input
                                    accept="application/pdf"
                                    multiple
                                    type="file"
                                    onChange={(event) => {
                                        this.props.uploadFile(
                                            event.target.files[0],
                                            (status) => {
                                                if (status.inProgress) {
                                                    this.setState({
                                                        fileProgress:
                                                            status.progress,
                                                    });
                                                } else if (status.finished) {
                                                    this.setState({
                                                        fileSuccess: true,
                                                        fileProgress: false,
                                                    });
                                                } else if (status.error) {
                                                    this.setState({
                                                        fileFail: true,
                                                    });
                                                }
                                            }
                                        );
                                    }}
                                    style={{
                                        display: "none",
                                    }}
                                    ref={(fileInput) =>
                                        (this.fileInput = fileInput)
                                    }
                                />
                                <Typography>
                                    {this.state.uploadFileName}
                                </Typography>
                                <Button
                                    color="primary"
                                    style={{
                                        width: "auto",
                                        display: "inline",
                                    }}
                                    onClick={() => {
                                        this.fileInput.click();
                                    }}
                                    variant="contained"
                                >
                                    Select File(s)
                                </Button>
                            </React.Fragment>
                        )}
                    </FormControl>
                </div>
                <Typography variant="h5">Uploaded Files:</Typography>
                <div>
                    <List dense={false}>
                        {profile.attached_files &&
                            profile.attached_files.map((e, i) => {
                                return (
                                    <ListItem
                                        key={i}
                                        onClick={() => {
                                            this.props.goToLink(
                                                `/pdf-viewer/job_pack/${profile.job_id}/attached-files/${i}`
                                            );
                                        }}
                                    >
                                        <ListItemAvatar>
                                            <Avatar>
                                                <FolderIcon />
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText primary={e.file} />
                                        <ListItemSecondaryAction>
                                            <IconButton
                                                aria-label="Delete"
                                                onClick={() => {
                                                    this.props.deleteFile(i);
                                                }}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                );
                            })}
                    </List>
                </div>
            </Paper>
        );
    }
}
